<template>
  <div class="list-renderer">
    <div class="list-table-container">
      <table>
        <thead>
          <tr>
            <th v-for="column in computedColumns" :key="column.name">
              {{ getColumnHeader(column) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="list.length > 0">
            <tr v-for="(item, index) in list" :key="index">
              <td
                v-for="column in computedColumns"
                :key="column.name"
                :style="{
                  maxWidth: column.mw ? `${column.mw}px` : 'auto',
                  minWidth: column.minw ? `${column.minw}px` : 'auto',
                  width: column.width ? `${column.width}px` : 'auto',
                }"
                :title="item[column.name]"
              >
                {{ item[column.name] }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div
      v-if="list.length === 0"
      class="no-items"
      style="text-align: center"
    >
      No Items
    </div>
    <div class="table-footer">Total Count: {{ total_count }}</div>
  </div>
</template>

<script>
import { snakeCaseToWords } from "../../../utility";
export default {
  name: "ListComponent",
  props: {
    list: {
      type: Array,
      required: true,
    },
    total_count: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Array,
      default: () => null,
    },
  },
  computed: {
    computedColumns() {
      // If columns are provided, use them directly
      if (this.columns && this.columns.length) {
        return this.columns;
      }
      // If no columns are provided, derive them from the first object in the list
      return this.list.length > 0
        ? Object.keys(this.list[0]).map((key) => ({
            name: key,
            type: "string",
          }))
        : [];
    },
  },
  methods: {
    getColumnHeader(column) {
      if (!column.label) {
        return snakeCaseToWords(column.name);
      }
      return this.$t(column.label);
    },
  },
};
</script>

<style scoped lang="scss">
.list-renderer {
  width: 100%;

  .list-table-container {
    width: 100%;
    overflow-x: auto;
    table {
      min-width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      color: #282828;
    }

    th,
    td {
      min-width: 100px;
      border: 1px solid hsl(0, 0%, 87%);
      padding: 8px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    th {
      background-color: hsl(0, 0%, 97%);
      font-weight: 500;
    }

    tr:nth-child(odd) {
      background-color: hsl(0, 0%, 94%);
    }

    tr:nth-child(even) {
      background-color: hsl(0, 0%, 91%);
    }
  }
  .no-items {
    background-color: hsl(0, 0%, 94%);
    padding: 8px;
    font-size: 13px;
  }
  .table-footer {
    margin-top: 4px;
    padding: 4px;
    background-color: hsl(0, 0%, 88%);
    text-align: right;
    font-size: 13px;
    border-radius: 4px;
  }
}
</style>